/* hys-sale-price.js
 * Storefront behaviour for the End of Summer Sale price callouts rendered by
 * snippets/hys-sale-price.liquid.
 * - Re-checks the promo window in the browser, because a page cached before
 *   the start (or during the sale) can outlive the boundary.
 * - Product page: follows the selected variant. Shows the projected sale price
 *   for promo variants and hides the callout for every other variant. Selection
 *   is read from the picker radios and matched against the variants JSON Venue
 *   embeds in <variant-radios> (same approach as hys-ansi-clearance.js, because
 *   the theme's on:variant:change event is unreliable). Falls back to the
 *   product form's hidden id input.
 * The discount itself is a Shopify automatic discount applied at checkout;
 * this only surfaces it.
 */
(function () {
  if (window.__hysSalePriceInit) return;
  window.__hysSalePriceInit = true;

  function inWindow(el) {
    var now = Date.now() / 1000;
    var start = parseInt(el.getAttribute('data-start'), 10);
    var end = parseInt(el.getAttribute('data-end'), 10);
    return !isNaN(start) && !isNaN(end) && now >= start && now <= end;
  }

  function escapeName(name) {
    return window.CSS && CSS.escape ? CSS.escape(name) : name;
  }

  function initCards() {
    var cards = document.querySelectorAll('.hys-sale-price--card');
    for (var i = 0; i < cards.length; i++) cards[i].hidden = !inWindow(cards[i]);
  }

  function initPdp(el) {
    if (el.__hysInit) return;
    el.__hysInit = true;

    var tiers = {};
    try {
      // Attribute holds the object body without outer braces (see snippet).
      tiers = JSON.parse('{' + (el.getAttribute('data-tiers') || '') + '}');
    } catch (err) {
      tiers = {};
    }

    // Scope to the surrounding product section so a quick-shop for another
    // product can't drive this callout.
    var scope = el.closest('section') || el.closest('[data-section]') || document;
    var host = scope.querySelector('variant-radios, variant-selects, variant-mixed-inputs');
    var variants = null;
    if (host) {
      var dataScript = host.querySelector('script[id^="all-variant-data"]')
        || host.querySelector('script[type="application/json"]');
      if (dataScript) {
        try {
          variants = JSON.parse(dataScript.textContent);
        } catch (err) {
          variants = null;
        }
      }
      if (!Array.isArray(variants)) variants = null;
    }

    var badge = el.querySelector('[data-sale-badge]');
    var was = el.querySelector('[data-sale-was]');
    var now = el.querySelector('[data-sale-now]');

    function selectedId() {
      if (host && variants) {
        var radios = host.querySelectorAll('input[type="radio"]');
        var names = [];
        for (var i = 0; i < radios.length; i++) {
          if (names.indexOf(radios[i].name) === -1) names.push(radios[i].name);
        }
        var values = [];
        for (var k = 0; k < names.length; k++) {
          var checked = host.querySelector('input[type="radio"][name="' + escapeName(names[k]) + '"]:checked');
          if (!checked) {
            values = null;
            break;
          }
          values.push(checked.value);
        }
        if (values && values.length) {
          for (var v = 0; v < variants.length; v++) {
            var opts = variants[v].options;
            if (!opts || opts.length !== values.length) continue;
            var match = true;
            for (var j = 0; j < opts.length; j++) {
              if (opts[j] !== values[j]) {
                match = false;
                break;
              }
            }
            if (match) return String(variants[v].id);
          }
        }
      }
      var idInput = scope.querySelector('form[action*="/cart/add"] input[name="id"]');
      return idInput ? String(idInput.value) : null;
    }

    function update() {
      var tier = tiers[selectedId()];
      if (!tier || !inWindow(el)) {
        el.hidden = true;
        return;
      }
      if (badge) badge.textContent = 'Save ' + tier.pct + '%';
      if (was) was.textContent = tier.was;
      if (now) now.textContent = tier.now;
      el.hidden = false;
    }

    // Delegated listener survives the theme re-rendering price/buttons.
    // Deferred a tick so the radio's checked state has settled.
    scope.addEventListener('change', function () {
      window.setTimeout(update, 0);
    });

    update();
  }

  function boot() {
    initCards();
    var els = document.querySelectorAll('hys-sale-price.hys-sale-price--pdp');
    for (var i = 0; i < els.length; i++) initPdp(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
